import React from 'react'
import { components, constants, useTranslation } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import EhblManifestKeys from 'src/constants/locale/key/EhblManifest'
import StatusNotificationFormProperties from './StatusNotificationFormProperties'
import Box from '@material-ui/core/Box'

const {
  button: { CngButton },
  form: { CngForm },
  CngDialog
} = components

const { FormState } = constants

function StatusNotificationDialog(props) {
  const {
    open,
    onAddStatusNotification,
    onClose,
    onEditStatusNotification,
    hblId,
    showNotification,
    statusNotification,
    type
  } = props

  const { initialValues, makeValidationSchema } =
    StatusNotificationFormProperties.formikProps

  const { translate } = useTranslation(Namespace.EHBL_MANIFEST)
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let title = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.StatusNotifyParties.TITLE
    )
    let saveButton = translate(
      Namespace.EHBL_MANIFEST,
      EhblManifestKeys.SAVE_BUTTON
    )

    return { title, saveButton }
  }

  return (
    <CngDialog
      dialogContent={
        <CngForm
          fieldLevel='form'
          formikProps={{
            initialValues: {
              ...(statusNotification || initialValues),
              hblId: hblId
            },
            makeValidationSchema: makeValidationSchema,
            onSubmit: (data) => {
              console.log("submit")
              if (type === 'EDIT') {
                onEditStatusNotification(data)
              } else {
                delete data.id

                onAddStatusNotification(data)
              }
              //onClose()
            }
          }}
          formState={FormState.COMPLETED}
          renderBodySection={(labelMap, shouldHideMap) => (
            <StatusNotificationFormProperties.Fields
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          renderButtonSection={() => (
            <Box display='flex' justifyContent='flex-end'>
              <CngButton color='primary' size='medium' type='submit'>
                {translatedTextsObject.saveButton}
              </CngButton>
            </Box>
          )}
        />
      }
      dialogTitle={translatedTextsObject.title}
      fieldLevel='toBeChangedByDeveloperIfWantFieldLevelRestriction'
      fullWidth
      maxWidth='md'
      onClose={(_, reason) => {
        if (reason !== 'backdropClick') {
          onClose()
        }
      }}
      open={open}
      shouldShowCloseButton
    />
  )
}

export default StatusNotificationDialog
